exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fe2-sink-http-header{color:white;padding-bottom:4px}\n", ""]);

// exports
